export default __webpack_public_path__ + "static/media/samplifierLogo_v2_72dpi.f96e6a3f.png";